var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcShield = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 37,
    fill: "none",
    viewBox: "0 0 28 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M13.625 9.904c-3.362 0-6.097 2.735-6.097 6.097 0 3.362 2.735 6.097 6.097 6.097 3.362 0 6.097-2.735 6.097-6.097 0-3.362-2.735-6.097-6.097-6.097zm3.62 4.948l-4.368 4.368c-.184.184-.424.276-.664.276-.24 0-.48-.092-.664-.276l-1.67-1.669c-.366-.366-.366-.96 0-1.327.367-.367.962-.367 1.328 0l1.006 1.005 3.704-3.704c.367-.367.96-.367 1.328 0 .366.366.366.96 0 1.327z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M27.218 8.682l-.001-.024c-.014-.308-.023-.633-.029-.995-.026-1.764-1.428-3.224-3.193-3.322-3.68-.206-6.526-1.405-8.957-3.776l-.021-.02c-.793-.727-1.99-.727-2.783 0l-.021.02c-2.432 2.37-5.278 3.57-8.957 3.776C1.49 4.439.088 5.899.062 7.663c-.005.36-.015.685-.029.995l-.001.057c-.072 3.752-.16 8.421 1.402 12.66.858 2.33 2.16 4.356 3.866 6.021 1.943 1.896 4.488 3.402 7.565 4.475.1.035.204.063.31.084.15.03.3.045.45.045.15 0 .301-.015.45-.045.106-.02.211-.05.312-.085 3.073-1.074 5.615-2.58 7.557-4.477 1.706-1.666 3.006-3.692 3.866-6.023 1.568-4.25 1.48-8.929 1.408-12.688zM13.625 23.975c-4.398 0-7.975-3.577-7.975-7.975 0-4.397 3.577-7.974 7.975-7.974 4.397 0 7.975 3.577 7.975 7.974 0 4.398-3.578 7.975-7.975 7.975z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcShield, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_shield.162abfa4.svg";
export { ForwardRef as ReactComponent };